/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Replicate_TitleInputs */

const en_admin_settings_groups_replicate_title = /** @type {(inputs: Admin_Settings_Groups_Replicate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replicate`)
};

/**
* | output |
* | --- |
* | "Replicate" |
*
* @param {Admin_Settings_Groups_Replicate_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_replicate_title = /** @type {((inputs?: Admin_Settings_Groups_Replicate_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Replicate_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_replicate_title(inputs)
});
export { admin_settings_groups_replicate_title as "admin.settings.groups.replicate.title" }